import { SurveyMessages, TranslationSurveyMessages } from "../interfaces";

export const messages: TranslationSurveyMessages = {
  [SurveyMessages.createSurveySuccess]: "Survey registrada con éxito",
  [SurveyMessages.createSurveyError]: "Error al crear nueva survey"
};
